import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'striphtml',
    standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
    transform(value: string): any {
        if (!value || !value.length) {
            return '';
        }

        return value.replace(/<.*?>/g, '');
    }
}
